module.exports = "/check02fc69ba82fa4791385bd6e1a8b12ec6.svg";